import * as React from "react";
import Header from "./Header";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import UploadIcon from "@mui/icons-material/Upload";
import Button from "@mui/material/Button";
import "./Header.css";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import "./VideoCard.css";
import VideoCard from "./VideoCard";
import axios from "axios";
import { config } from "../App";
import { useSnackbar } from "notistack";
import "./LandingPage.css";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import UploadModel from "./UploadModel";

let genre = ["All genre", "Education", "Sports", "Comedy", "Lifestyles"];

let ageGroup = ["Any Age", "7+", "12+", "16+", "19+"];

const arr = [];
const LandingPage = ({ hasAuthButtons }) => {
  const [videoList, setVideosList] = useState([]);
  const [debounceTimeout, setDebounceTimeout] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [openUploadModel, setopenUploadModel] = useState(false);
  //const [multiSelectArray, setmultiSelectArray] = React.useState(genre[0]);

  const { enqueueSnackbar } = useSnackbar();

  const getVideos = async (query) => {
    try {
      let url = `${config.endpoint}/v1/videos`;
      if (query) {
        url = `${url}?title=${query}`;
      }
      const data = await axios.get(url);
      setVideosList(data.data.videos);
    } catch (e) {
      if (e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Something went wrong Check that the backend is running, reachable and returns valid JSON",
          { variant: "error" }
        );
      }
    }
  };

  //debouncing method
  useEffect(() => {
    if (debounceTimeout !== 0) {
      clearTimeout(debounceTimeout);
    }
    const newTimeout = setTimeout(() => getVideos(searchInput), 800);
    // console.log(newTimeout); // 2
    setDebounceTimeout(newTimeout);
  }, [searchInput]);

  useEffect(() => {
    getVideos();
  }, []);

  //on clicking the genres this function will triggerd
  const genreFilter = async (genreselect) => {
    if (genreselect === "All genre") {
      const data = await axios.get(`${config.endpoint}/v1/videos?genres=All`);
      setVideosList(data.data.videos);
    } else {
      arr.push(genreselect);
      if (genreselect === "Education") {
        const data = await axios.get(
          `${config.endpoint}/v1/videos?genres=Education`
        );
        setVideosList(data.data.videos);
      } else if (arr.length > 0) {
        try {
          let genres = arr.join();
          const data = await axios.get(
            `${config.endpoint}/v1/videos?genres=${genres}`
          );
          setVideosList(data.data.videos);
        } catch (e) {
          enqueueSnackbar(e.response.data.message, { variant: "error" });
        }
      }
    }
  };

  //for the filtering the videos based on age
  //on clicking the genres this function will triggerd
  const ageFilter = async (ageSelect) => {
    try {
      const data = await axios.get(
        `${config.endpoint}/v1/videos?contentRating=12%2B`
      );
      setVideosList(data.data.videos);
    } catch (e) {
      if (e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Something went wrong Check that the backend is running, reachable and returns valid JSON",
          { variant: "error" }
        );
      }
    }
  };

  const onInputChange = (event) => {
    setSearchInput(event.target.value);
  };

  //sorting function
  const sortChange = async (event) => {
    try {
      const data = await axios.get(
        `${config.endpoint}/v1/videos?sortBy=${event.target.value}`
      );
      setVideosList(data.data.videos);
    } catch (e) {
      if (e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Something went wrong Check that the backend is running, reachable and returns valid JSON",
          { variant: "error" }
        );
      }
    }
  };
  //uploadmodel show
  const handleUploadShow = () => {
    setopenUploadModel(true);
  };
  const handleCancel = () => {
    setopenUploadModel(false);
  };
  return (
    <div>
      {!hasAuthButtons && (
        <>
          <Header>
            <Paper
              className="header-item"
              component="form"
              sx={{
                p: "2px 4px",
                display: "flex",
                alignItems: "center",
                width: 400,
              }}
            >
              <InputBase
                value={searchInput}
                sx={{ ml: 1, flex: 1 }}
                placeholder="Search"
                inputProps={{ "aria-label": "Search" }}
                onChange={onInputChange}
              />
              <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
                <SearchIcon />
              </IconButton>
            </Paper>
            <Button
              variant="contained"
              component="label"
              sx={{
                height: "50%",
              }}
              m={2}
              className="header-item"
              onClick={handleUploadShow}
            >
              <UploadIcon />
              Upload
            </Button>
            <UploadModel open={openUploadModel} cancelHandler={handleCancel} />
          </Header>
          <div id="genre-panel" className="genrePanel">
            <div>
              {genre.map((genreItem, index) => {
                return (
                  <Button
                    key={Math.random(index)}
                    variant="text"
                    className="genre-button"
                    onClick={() => genreFilter(genreItem)}
                  >
                    {genreItem}
                  </Button>
                );
              })}

              <FormControl
                sx={{
                  m: 1,
                  minWidth: 80,
                  bgcolor: "white",
                  borderRadius: 16,
                  border: "none",
                  height: "2.2rem",
                  color: "rgba(0, 0, 0, 0.87)",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  fontFamily: "Roboto",
                }}
              >
                <Select
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  defaultValue="sortBy"
                  onChange={sortChange}
                  autoWidth
                  sx={{
                    height: "2.2rem",
                    borderRadius: 16,
                    fontSize: ".9rem",
                    letterSpacing: "0.00938em",
                    lineHeight: "1.4375em",
                  }}
                >
                  <MenuItem value="sortBy" disabled>
                    Sort By
                  </MenuItem>
                  <MenuItem value="releaseDate">ReleaseDate</MenuItem>
                  <MenuItem value="viewCount">viewCount</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div>
              <div>
                {ageGroup.map((age, index) => {
                  return (
                    <Button
                      key={Math.random(index)}
                      variant="text"
                      className="genre-button"
                      onClick={() => {
                        ageFilter(age);
                      }}
                    >
                      {age}
                    </Button>
                  );
                })}
              </div>
            </div>
          </div>
        </>
      )}
      <div>
        <Grid container className="dashBoard" spacing={2}>
          {videoList.map((videoContent) => {
            const {
              votes,
              previewImage,
              viewCount,
              _id,
              videoLink,
              title,
              genre,
              contentRating,
              releaseDate,
            } = videoContent;

            return (
              <Grid item xs={12} sm={6} md={4} lg={3} key={Math.random()}>
                <VideoCard
                  imgLink={previewImage}
                  id={_id}
                  view={viewCount}
                  title={title}
                  releaseDate={releaseDate}
                />
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
};
export default LandingPage;
